import { FormItem } from 'd-element-ui'
import Vue from 'vue'
import VueRouter, { RouteConfig } from 'vue-router'

// 屏蔽NavigationDuplicated: Avoided redundant navigation to current location错误信息
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location: any) {
    return (originalPush.call(this, location) as any).catch((err: any) => err)
}
Vue.use(VueRouter)
const routeBaseConfig = '/helpCenter'
const routesList = [
    {
        path: '/document/:type/:id',
        name: 'document',
        webComponent: '/document.vue',
        mobileComponent: '/document.vue'
    },
    {
        path: '/videoPlayer/:type/:id',
        name: 'videoPlayer',
        webComponent: '/videoPlayer.vue',
        mobileComponent: '/videoPlayer.vue'
    },
    {
        path: '/SearchResult',
        name: 'SearchResult',
        webComponent: '/SearchResult.vue',
        mobileComponent: '/pages_wap/SearchResult.vue'
    },
    {
        path: '/allVideo',
        name: 'allVideo',
        webComponent: '/AllVideo.vue',
        mobileComponent: '/pages_wap/AllVideo.vue'
    },
    {
        path: '/allDocument',
        name: 'allDocument',
        webComponent: '/AllDocument.vue',
        mobileComponent: '/pages_wap/AllDocument.vue'
    },
    {
        path: '/NoviceDetail',
        name: 'NoviceDetail',
        webComponent: '/NoviceDetail.vue',
        mobileComponent: '/pages_wap/novice/NoviceDetail.vue'
    },
    {
        path: '/Question',
        name: 'Question',
        webComponent: '/Question.vue',
        mobileComponent: '/pages_wap/question/index.vue',
        // component: () => import(`../views${newjj}.vue`),
        redirect: (res: {params: {ntwId: string}}) => `/${res.params.ntwId}/Question/QuestionContents`,
        children: [
            {
                path: '/Question/QuestionContents',
                name: 'QuestionContents',
                webComponent: '/QuestionContents.vue',
                mobileComponent: '/pages_wap/question/QuestionContents.vue',
                // component: () => import('/pages_wap/question/QuestionContents.vue')
            },
            {
                path: '/Question/QuestionDetail',
                name: 'QuestionDetail',
                webComponent: '/QuestionDetail.vue',
                mobileComponent: '/pages_wap/question/QuestionDetail.vue',
                // component: () => import('/pages_wap/question/QuestionDetail.vue')
            }
        ]
    },
    {
        path: '/Video',
        name: 'Video',
        webComponent: '/Video.vue',
        mobileComponent: '/pages_wap/video/index.vue',
        redirect: (res: {params: {ntwId: string}}) => `/${res.params.ntwId}/Video/VideoList`,
        children: [
            {
                path: '/Video/VideoList',
                name: 'VideoList',
                webComponent: '/VideoList.vue',
                mobileComponent: '/pages_wap/video/VideoList.vue'
            },
            {
                path: '/Video/VideoDetail',
                name: 'VideoDetail',
                webComponent: '/VideoDetail.vue',
                mobileComponent: '/pages_wap/video/VideoDetail.vue'
            }
        ]
    },
    {
        path: '/Novice',
        name: 'Novice',
        webComponent: '/Novice.vue',
        mobileComponent: '/pages_wap/novice/index.vue'
    },
    {
        path: '/Download',
        name: 'Download',
        webComponent: '/Download.vue',
        mobileComponent: '/pages_wap/Download.vue'
    },
    {
        path: '/feedback',
        name: 'feedback',
        webComponent: '/feedback.vue',
        mobileComponent: '/pages_wap/feedback.vue'
    },
    {
        path: '/index',
        name: 'index',
        webComponent: '',
        mobileComponent: '/pages_wap/index.vue'
    },
    {
        path: '/Search',
        name: 'Search',
        webComponent: '',
        mobileComponent: '/pages_wap/Search.vue'
    },
    {
        path: '/getToken',
        name: 'getToken',
        webComponent: '/pages_wap/getToken.vue',
        mobileComponent: '/pages_wap/getToken.vue'
    }
]
function addNtwId(list: any) {
    list.forEach((item: any) => {
        item.component = () => import(`../views${document.body.clientWidth > 767 ? item.webComponent : item.mobileComponent}`)
        if (item.name !== 'videoPlayer' && item.name !== 'document') {
            item.path = '/:ntwId' + item.path
        }
        if (item.children) {
            addNtwId(item.children)
        }
        return item
    })
    return list
}
let router = new VueRouter({
    mode: 'history',
    base: routeBaseConfig,
    routes: addNtwId(routesList)
})
export default router
